module.exports = __webpack_public_path__ + "img/symbol-theta-left.fb34c46c.png";